import { Timestamp, toDateTimeStr } from '@mi-front/core';
import { SegmentsWaveform, TimeViewport } from '@mi-front/ui';
import { convertSegmentsToRelative } from '../../../../../../../joint-fragments/helpers/helpers';
import { DisplayableChunk } from '../../../../../../types';

interface ChunkWaveformSvgProps {
  chunk: DisplayableChunk;
  color: string;
  relativeTs: Timestamp;
}

/**
 * Renders the SVG waveform for a chunk.
 * Uses TimeViewport to position the waveform correctly in the stream.
 */
export function ChunkWaveformSvg({ chunk, color, relativeTs }: ChunkWaveformSvgProps) {
  return (
    <g data-testid="chunk-waveform">
      <TimeViewport
        id={chunk.from}
        range={{
          from: toDateTimeStr(relativeTs),
          to: toDateTimeStr(relativeTs + chunk.duration),
        }}
      >
        <SegmentsWaveform
          key={chunk.from}
          segments={convertSegmentsToRelative(relativeTs, chunk.segments)}
          fgColor={color}
        />
      </TimeViewport>
    </g>
  );
}
